/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { DedicatedEndpointType } from '@fai/friendli-suite/generated/client/graphql';

import type { EndpointFormSchema } from './schema';

export const initialValues: EndpointFormSchema = {
  name: '',
  type: DedicatedEndpointType.Development,
  model: {
    type: null,
    huggingFace: {
      repositoryName: '',
      repositoryRevision: null,
      adapters: [],
    },
    wandb: {
      artifactName: '',
      adapters: [],
    },
    native: {
      modelId: '',
      modelName: '',
      adapters: [],
    },
  },
  instance: {
    name: undefined,
    optionId: '',
  },
  configuration: {
    scale: {
      type: 'autoscaling',
      simple: { replicas: 1 },
      autoscaling: { min: 0, max: 2, cooldown: 300 },
    },
    advanced: {
      maxBatchSize: 256,
      tokenizerAddSpecialTokens: true,
      tokenizerSkipSpecialTokens: true,
      enableContentLogging: true,
    },
  },
};
